export default "__VITE_ASSET__DFg6$9wf__"